import React from "react";
import { Navigate } from "react-router-dom";
import CsrManualSubscriptionSection from "../../components/SubscriptionHistory/CsrManualSubscriptionSection";

const ALLOWED = ["CSR", "CSR Team Lead"];

const CsrManualSubscription = () => {
  const userRole = localStorage.getItem("adminUserRole") || "";
  if (!ALLOWED.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="p-4 md:p-6">
      <CsrManualSubscriptionSection />
    </div>
  );
};

export default CsrManualSubscription;
